import styled from 'styled-components';

export const DotsWrapper = styled.div`
  min-width: 30px;
  display: flex;
  justify-content: center;
  align-items: center;

  padding: 1px 0;
  border-radius: 4px;

  background-color: transparent;
`;
